fx.ns("models", class PageLayout extends fx.Model {

	constructor(data)
	{
        super(data);
    }

    get defaults()
    {
        return { components : [] };
    }


    getBackground()
    {
        let bg;
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (component.isBackground)
            {
                bg = component;
                break;
            }
        }

        return bg;
    }
    
});